import Sidebar from 'src/components/ui/sidebar';
import { InventoryTable } from './InventoryTable/InventoryTable';

export const InventoryPage = () => {
  return (
    <Sidebar>
      <InventoryTable />
    </Sidebar>
  );
};
